import { boolean, defineAction, number, object, string } from '~/prix'
import legalEntityMassGeocodeAction from './legalEntityMassPartialGeocode.action.json'

const legalEntityMassGeocodeDefinition = defineAction({
  ...legalEntityMassGeocodeAction,
  input: object({
    concurrency: number().isOptional(),
    saveLogsToFolder: string().isOptional(),
    cityName: string().isOptional(),
    update: boolean().isOptional(),
  }),
  output: object({}),
})

export default legalEntityMassGeocodeDefinition
